import { render, staticRenderFns } from "./postdoctorAcademic.vue?vue&type=template&id=6ccad567&scoped=true&"
import script from "./postdoctorAcademic.vue?vue&type=script&lang=js&"
export * from "./postdoctorAcademic.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorAcademic.vue?vue&type=style&index=0&id=6ccad567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccad567",
  null
  
)

export default component.exports